var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 17.438c0-.141.047-.235.14-.329L14.064 6.187l3.75 3.75L6.89 20.86a.5.5 0 0 1-.328.141H3.516A.52.52 0 0 1 3 20.484zM20.719 7.03 18.89 8.86l-3.75-3.75 1.828-1.828a1.02 1.02 0 0 1 1.406 0l2.344 2.344a1.02 1.02 0 0 1 0 1.406"
  })));
};
export default SvgEdit;